import * as React from 'react';
import type { SVGProps } from 'react';
const SvgProgressIndicator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 75 74"
    {...props}
  >
    <path
      fill="#292A33"
      fillRule="evenodd"
      d="M37.626.184c20.269 0 36.7 16.436 36.7 36.699 0 20.27-16.431 36.703-36.7 36.703C17.36 73.586.933 57.154.933 36.883.933 16.62 17.36.183 37.626.183"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m32.116 51.61 1.207 2.695a4.54 4.54 0 0 0 1.686 1.962 4.6 4.6 0 0 0 4.982 0 4.54 4.54 0 0 0 1.686-1.962l1.207-2.694a5 5 0 0 1 2.066-2.278 5.06 5.06 0 0 1 3.036-.64l2.953.312c.88.092 1.767-.07 2.555-.469a4.55 4.55 0 0 0 1.884-1.775 4.5 4.5 0 0 0-.262-4.936l-1.749-2.384a4.95 4.95 0 0 1-.95-2.941c0-1.053.336-2.078.96-2.93l1.748-2.384a4.51 4.51 0 0 0 .262-4.936 4.55 4.55 0 0 0-1.884-1.775 4.6 4.6 0 0 0-2.554-.469l-2.954.312a5.06 5.06 0 0 1-3.036-.64 5 5 0 0 1-2.066-2.289l-1.216-2.694a4.54 4.54 0 0 0-1.686-1.962 4.6 4.6 0 0 0-4.982 0 4.54 4.54 0 0 0-1.686 1.962l-1.207 2.694a5 5 0 0 1-2.065 2.29 5.06 5.06 0 0 1-3.037.64l-2.962-.313a4.6 4.6 0 0 0-2.555.47 4.55 4.55 0 0 0-1.884 1.774 4.51 4.51 0 0 0 .262 4.936l1.748 2.385a4.95 4.95 0 0 1 0 5.858l-1.748 2.385a4.51 4.51 0 0 0-.262 4.936 4.56 4.56 0 0 0 1.884 1.774 4.6 4.6 0 0 0 2.555.47l2.953-.312a5.06 5.06 0 0 1 3.036.64 5 5 0 0 1 2.075 2.289"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M37.496 42.65c3.422 0 6.197-2.753 6.197-6.15s-2.774-6.15-6.197-6.15S31.3 33.103 31.3 36.5s2.774 6.15 6.196 6.15"
    />
  </svg>
);
export default SvgProgressIndicator;
